import { GENERIC_WINDOW_STYLE } from '../Elements/Windows/Window_Generic';

/**
 * state for warning about incompatible browsers / platforms
 */
export class IncompatibleWarning {
  /**
   * Phaser state init
   */
  init() {
    //
  }

  /**
   * Phaser create
   */
  create() {
    this._windowMgr = new G.WindowMgr();
    this._windowMgr.addLayerToWorld('base', {});
    this._showIE11Warning();
  }

  /**
   * show a warning for IE 11 users
   */
  _showIE11Warning() {
    // eslint-disable-next-line max-len
    const txt = OMT.language.getText('Unfortunately, we are ending support for Internet Explorer 11. To play, please continue on a modern browser. For support on switching browsers, please contact: support@softgames.de');
    const img = G.makeImage(0, 0, 'sad_gingy_heart_small', [0.5, 0], null);
    const config = {
      windowStyle: GENERIC_WINDOW_STYLE.TEMPLATE,
      template: {
        text: {
          text: `${txt}\n\nPlayer ID`,
          textStyle: 'font-purple',
          boundaries: {},
          offset: { y: 5 },
        },
        image: {
          image: img,
        },
      },
    };
    G.sb('pushWindow').dispatch(['Generic', config]);
  }
}
